import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'concurrent',
  template: `
  <main class="page-content">
    <h1>{{concurrentLogoutTitle}}</h1>
    <p>{{concurrentLogoutText}}</p>
  </main>
  `,
  styleUrls: ['./concurrent.component.scss']
})
export class ConcurrentComponent implements OnInit {
  concurrentLogoutTitle: string =  "You have been logged out.";
  concurrentLogoutText: string = "You have been logged out because you logged in at another location or from another browser.  Security policy allows only 1 concurrent login.";
  stateInfo: any;
  constructor(private router: Router) {
    this.stateInfo = this.router.getCurrentNavigation().extras.state;
  }

  ngOnInit() {
    if (this.stateInfo.status != 401) {
      this.concurrentLogoutText = "You have been logged out because of a connectivity issue.";
    }
  }
}
